var youbora = require('youboralib')
var manifest = require('../../manifest.json')

var GenericAdsAdapter = youbora.Adapter.extend({
  /** Override to return current plugin version */
  getVersion: function () {
    return manifest.version + '-' + manifest.name + '-' + manifest.tech
  },

  getPlayhead: function () {
    return this.player.currentTime > this.player.duration ? null : this.player.currentTime
  },

  getResource: function () {
    return this.player.src
  },

  getPlayerName: function () {
    return 'Dailymotion'
  },

  getPosition: function () {
    if (this.plugin.getAdapter().flags.isJoined) {
      return 'mid'
    } else {
      return 'pre'
    }
  },

  /** Register listeners to this.player. */
  registerListeners: function () {

    // References
    this.references = []
    this.references['ad_play'] = this.playListener.bind(this)
    this.references['ad_pause'] = this.pauseListener.bind(this)
    this.references['ad_start'] = this.startListener.bind(this)
    this.references['ad_end'] = this.endListener.bind(this)

    // Register listeners
    for (var key in this.references) {
      this.player.addEventListener(key, this.references[key])
    }
  },

  /** Unregister listeners to this.player. */
  unregisterListeners: function () {

    // unregister listeners
    if (this.player && this.references) {
      for (var key in this.references) {
        this.player.removeEventListener(key, this.references[key])
      }
      this.references = []
    }
  },

  /** Listener for 'ad_play' event. */
  playListener: function (e) {
    if (this.flags.isJoined) {
      if (!this.flags.isPaused) {
        this.fireStop()
        this.fireStart()
        this.fireJoin()
      }
    }
    this.fireJoin()
    this.fireResume()
  },

  /** Listener for 'ad_pause' event. */
  pauseListener: function (e) {
    this.firePause()
  },

  /** Listener for 'ad_start' event. */
  startListener: function (e) {
    this.fireStart()
  },

  /** Listener for 'ad_end' event. */
  endListener: function (e) {
    this.fireStop()
  }
})

module.exports = GenericAdsAdapter
